import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AllotmentDetailService } from '../../../allotment-detail.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { PostingOrderService } from '../../../posting-order.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Loader/loader/loader.component';

@Component({
  selector: 'app-zing-hrposting-order',
  standalone: true,
  imports: [LoaderComponent, RouterModule, CommonModule, DataTablesModule, NgSelectModule, FormsModule],
  templateUrl: './zing-hrposting-order.component.html',
  styleUrl: './zing-hrposting-order.component.scss'
})
export class ZingHRPostingOrderComponent {
  isDisabled: boolean = false;
  isSubContractor: boolean = false;
  user: any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  TableData = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  dtoptions: DataTables.Settings = {};
  constructor(
    public common: CommonService,
    private session: SessionService,
    private postingService: PostingOrderService,
    private download: DownloadSampleService,
    private comboload: ComboService,
    private allotmentService: AllotmentDetailService
  ) {
    this.common.getPageRights();
    this.isSubContractor = window.location.pathname.includes('postingordersub');
    this.user = this.session.GetUserDetails();
    this.Filter.LoginUserID = this.user.UserId
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    //this.ComboLoad('Branch')
    this.AllotmentView();
  }

  Filter = {
    SelectType: 'ZingHr Transfer Order',
    EmpMasterID: '0',
    LoginUserID: '0',
    DesignationID: '',
    GroupID: '',
    DutyID: '',
    BankAccountNo: '',
    FinancialYear: '',
    BranchId: null as any,
    ClientId: null as any,
    SiteId: null as any
  }

  AllotmentView() {
    this.isDisabled = true
    this.allotmentService.AllotmentView({
      SelectType: 'ZingHr Transfer Order',
      LoginUserID: Number(this.user.UserId),
      BranchId: this.Filter.BranchId == null ? 0 : this.Filter.BranchId,
      ClientId: this.Filter.ClientId == null ? 0 : this.Filter.ClientId,
      SiteId: this.Filter.SiteId == null ? 0 : this.Filter.SiteId,
    }).subscribe({
      next: (response) => {
        // this.TableData = Object.values(response.Table);
        this.TableData = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    if (this.TableData.length > 0) {
      this.download.exportToExcel(this.TableData, "Posting Order Data");
      this.isDisabled = false
    }
    else {
      //this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
      alert('No Data Found');
      this.isDisabled = false
    }
  }
}
